import { RefObject } from "react";
import useForm from "../../../../../custom-hooks/form/useForm";
import useFormWarning from "../../../../../custom-hooks/form/useFormWarning";
import useInputChangeHandler from "../../../../../custom-hooks/form/handlers/useInputChangeHandler";
import useCheckboxChangeHandler from "../../../../../custom-hooks/form/handlers/useCheckboxChangeHandler";
import useSelectChangeHandler from "../../../../../custom-hooks/form/handlers/useSelectChangeHandler";

type UseNetworkCreateFormProps = {
  regionRef: RefObject<HTMLElement>;
};

const useNetworkDuplicateForm = ({ regionRef }: UseNetworkCreateFormProps) => {
  const { formWarning, showFormWarning, hideFormWarning } = useFormWarning();

  const { formData, error, handleChange } = useForm({
    validations: [
      {
        field: "region",
        requiredMessage: "Please select a region.",
        ref: regionRef,
      },
    ],
    initialState: {
      portSecurity: true,
    },
  });

  const handleInputChange = useInputChangeHandler({
    handleChange,
    hideFormWarning,
  });
  const handleCheckboxChange = useCheckboxChangeHandler({
    handleChange,
    hideFormWarning,
  });
  const handleSelectChange = useSelectChangeHandler({
    handleChange,
    hideFormWarning,
  });

  return {
    formWarning,
    showFormWarning,
    error,
    formData,
    handleInputChange,
    handleSelectChange,
    handleCheckboxChange,
  };
};

export default useNetworkDuplicateForm;
